import { apiClient } from './api';
import type {
  CreateConnectSessionApiRequest,
  CreateConnectSessionApiResponse,
  GetAllIntegrationsApiResponse,
  GetAdminIntegrationStatusApiResponse,
  RegisterWebhookApiResponse,
} from '@momentum/types';

export const integrationsService = {
  async createConnectSession(
    body?: CreateConnectSessionApiRequest
  ): Promise<CreateConnectSessionApiResponse> {
    return (await apiClient.post(`/integrations/nango/connect/session`, body))
      .data;
  },

  async getAllIntegrations(
    companyId: string
  ): Promise<GetAllIntegrationsApiResponse> {
    return (await apiClient.get(`/companies/${companyId}/integrations`)).data;
  },

  async getAdminIntegrationStatus(): Promise<GetAdminIntegrationStatusApiResponse> {
    return (await apiClient.get(`/integrations/nango/admin/status`)).data;
  },

  async deleteIntegration(
    companyId: string,
    integrationId: string
  ): Promise<void> {
    await apiClient.delete(
      `/companies/${companyId}/integrations/${integrationId}`
    );
  },

  async registerWebhook(
    companyId: string,
    integrationId: string
  ): Promise<RegisterWebhookApiResponse> {
    return (
      await apiClient.post(
        `/companies/${companyId}/integrations/${integrationId}/register-webhook`
      )
    ).data;
  },

  async getComposioConnectUrl(
    toolkit: string
  ): Promise<{ connectUrl: string }> {
    return (
      await apiClient.post('/integrations/composio/connect/url', { toolkit })
    ).data;
  },

  async getComposioStatus(): Promise<{
    connections: Record<string, boolean>;
  }> {
    return (await apiClient.get('/integrations/composio/status')).data;
  },

  async syncIntegration(
    companyId: string,
    integrationId: string
  ): Promise<{
    success: boolean;
    totalIssues: number;
    levelsProcessed: number;
  }> {
    return (
      await apiClient.post(
        `/sync/${integrationId}?companyId=${companyId}`,
        undefined,
        { timeout: 20_000 }
      )
    ).data;
  },
};
